/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What tools are coming next?`)
};

const es_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué herramientas llegarán próximamente?`)
};

const de_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Werkzeuge kommen als Nächstes?`)
};

const nl_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke tools komen er nog aan?`)
};

const fr_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels outils arrivent ensuite ?`)
};

const it_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali strumenti arriveranno prossimamente?`)
};

const pt_br2_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais ferramentas estão por vir?`)
};

const pt_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que ferramentas estão a chegar a seguir?`)
};

const ja_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次に追加されるツールは？`)
};

const zh_home_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下来会推出哪些工具？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_faq4_q", locale)
	if (locale === "en") return en_home_faq4_q(inputs)
	if (locale === "es") return es_home_faq4_q(inputs)
	if (locale === "de") return de_home_faq4_q(inputs)
	if (locale === "nl") return nl_home_faq4_q(inputs)
	if (locale === "fr") return fr_home_faq4_q(inputs)
	if (locale === "it") return it_home_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_home_faq4_q(inputs)
	if (locale === "pt") return pt_home_faq4_q(inputs)
	if (locale === "ja") return ja_home_faq4_q(inputs)
	return zh_home_faq4_q(inputs)
};